import styled from 'styled-components'

export const ManagePageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    padding-top: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        padding: 0 2rem;
        padding-top: 2rem;
    `}

`;

export const ManageContent = styled.div`
    width: 100%;
    flex: 1;
    width: 80%;
    padding-top: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;


export const ManageHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}
`;

export const ManageHeaderContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 2rem;
    //min-height: calc(100% - 76px);
    background-color: ${({ theme }) => theme.newBg1};
    border-radius: 0.5rem 0.5rem 0 0;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    `}
`;


export const ManageImage = styled.div`
    height: 150px;
    width: 150px;
    z-index: 1;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 1rem;
    margin-right: 1rem;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        align-self: center;
    `}
    
    > img {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        object-fit: cover;
    }
`;

export const ManageInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 60%;
    color: #fff;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        font-size: 0.8rem;
    `}

`;

export const ManageTitle = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin: 1rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    svg {
        width: 1.5rem;
        margin-right: 0.5rem;
        fill: rgb(32, 129, 226);
    }
`

export const ManageCountdown = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    height: 100%;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
    `}
`;

export const ManageHeaderBottom = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    background-color: ${({ theme }) => theme.newBg2};
    border-radius: 0 0 0.5rem 0.5rem;
`;

export const ManageBottomItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 200px;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    margin: 0.5rem;
    box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.2);

    > span {
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 0.5rem;
        color: ${({ theme }) => theme.yetiBlue};
    }

    > div {
        font-size: 0.9rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 150px;
        display: flex;
        align-items: center;

        > img {
            width: 1rem;
            height: 1rem;
            margin-left: 5px;
        }
    }
`

export const PageWrapper = styled.div`
  max-width: 1024px;
  width: 100%;

  @media only screen and (max-width: 1024px) {
    padding: 0 10px;
  }

  .stakeManageHead {
    width: 100%;
    margin: 15px 0;

    .stakeManageLogoWrapper {
      position: relative;

      .stakeCountdown {
        position: absolute;
        bottom: 0;
        z-index: 10;
        background: ${({ theme }) => theme.bg7};
        border-radius: 5px;
        color: #fff;
        padding: 10px;
        font-size: 14px;
      }

      .stakeManageLogo {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 250px;
        }
      }
    }

    .stakeManageTitle {
      width: 100%;
      font-size: 1.5rem;
      text-align: center;
      margin: 15px 0;
    }

    .stakingManageInfo {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .stakingManageInfoItem {
        width: 100%;
        text-align: left;
        font-size: 1rem;

        .stakingManageInfoItemValue {
          font-size: 1.5rem;
        }
      }
    }
  }

  .stakeManageBody {
    width: 100%;

    .stakeMangeRate {
      width: 100%;
      background-color: ${({ theme }) => theme.bg3};
      margin-bottom: 10px;

      .stakeAccountBalance {
        background: radial-gradient(76.02% 75.41% at 1.84% 0%, #98c1d9 0%, #3d5a80 100%);
        font-size: 1.2rem;
        padding: 20px;
        color: #fff;

        .stakedAccountBalanceValue {
          display: flex;
          justify-content: space-between;

          .stakedAccountBalanceInfo {
            font-size: 2rem;
          }
        }
      }

      .stakeAccountRate {
        width: 100%;
        font-size: 1.2rem;
        padding: 20px;

        .stakeAccountRateValue {
          display: flex;
          justify-content: space-between;

          .stakeAccountRateUnclaimed {
            font-size: 2rem;
          }
        }
      }
    }

    .stakeWidthDrawAll {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 20px;

      .stakeWidthDrawAllButton {
        text-align: center;
        padding: 1rem;
        margin-top: 0.5rem;
        width: fit-content;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .stakedSection {
      .stakedMenu {
        margin-bottom: 20px;
        ul {
          list-style: none;
          display: flex;
          margin: 0;
          padding: 0;

          li {
            margin-right: 1rem;
            font-size: 1.2rem;
            color: ${({ theme }) => theme.text3};
            cursor: pointer;
            user-select: none;

            &.active {
              color: ${({ theme }) => theme.text1};
              border-bottom: solid 1px;
            }
          }
        }
      }

      .stakedList {
        display: grid;
        width: 100%;
        grid-template-rows: repeat(1, minmax(400px, min-content));
        grid-template-columns: repeat(4, minmax(250px, 1fr));
        grid-auto-rows: 400px;
        grid-gap: 11px;

        @media only screen and (max-width: 768px) {
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

          .nft-card-view {
            width: 100%;
          }
        }

        @media only screen and (max-width: 425px) {
          grid-template-columns: repeat(1, minmax(250px, 1fr));
        }
      }
    }
  }
`
